import gameReducer from "reducers/gameReducer";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
  gameReducer,
});

export default rootReducer;
